// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card[data-v-439e4b90] {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, calc(-50% + 20px));\n          transform: translate(-50%, calc(-50% + 20px));\n}", ""]);
// Exports
module.exports = exports;
